import {DomManager, DomManagerOptions} from "./dommanager.mjs";
import {LayoutOptions, PartsOptions} from "./docprovider.mjs";
import {EventManager} from "./eventmanager.mjs";
import {StorageManager} from "./storagemanager.mjs";

export class Component{
    constructor(componentOptions){
        var _contentOptions;
        var _domManager; 
        var _eventManager;
        var _storageManager;

        Object.defineProperty(this,'domManager',{
            set : function(d){ _domManager = d },
            get : function(){ return _domManager}
        });

        Object.defineProperty(this,'contentOptions',{
            set : function(c){ _contentOptions = c },
            get : function(){ return _contentOptions }
        });

        Object.defineProperty(this,'eventManager',{
            set : function(e){ _eventManager = e },
            get : function(){ return _eventManager }
        });

        Object.defineProperty(this,'storageManager',{
            set : function(s){ _storageManager = s } ,
            get : function(){ return _storageManager }
        });

        // runtime
        this.initComponent(componentOptions)
    }

    // =======
    // private
    // -------
    setDomManager(x){ this.domManager = x }
    getDomManager(){ return this.domManager }

    setEventManager(e){ this.eventManager = e }
    getEventManager(){ return this.eventManager; }

    setStorageManager(s){ this.storageManager = s; }
    getStorageManager(){ return this.storageManager; }

    getContentOptions(){ return this.contentOptions; }

    hasComponentOptions(componentOptions){
        return (componentOptions && (componentOptions instanceof ComponentOptions));
    }

    /* only a node without childs */
    createContainerOptions(context){
        var createBodyNodes = this.createContainerNode.bind(this);
        var createHeadNodes = this.createHeadNode.bind(this);
        var partsOptions = new PartsOptions(createBodyNodes, createHeadNodes, context);
        return partsOptions;
    }

    createContentOptions(context){
        var createBodyNodes = this.createContentNode.bind(this);
        //var createHeadNodes = this.createHeadNode.bind(this);
        var partsOptions = new PartsOptions(createBodyNodes, undefined, context);
        return partsOptions;
    }

    initDomManager(domManagerOptions){
        var domManager = new DomManager(domManagerOptions);
        this.setDomManager(domManager);
    }

    initEventManager(){
        var eventManager = new EventManager();
        this.setEventManager(eventManager);
    }

    initEventManagerListeners(){
        var eventManager = this.getEventManager();
        var domNode = this.getDomManager().getDomNode();
        eventManager.setListeners(domNode);
    }

    updateManagerListeners(){  
        var eventManager = this.getEventManager();
        var domNode = this.getDomManager().getDomNode();
        eventManager.updateListeners(domNode)
    }

    initEventListeners(){
        this.defineEventListeners.call(this,this.getEventManager());
    }

    initStorageManager(){
        var storageManager = new StorageManager();
        this.setStorageManager(storageManager);
    }

    

    insertSubComponents(){  /* should be called addSubComponents */
        var storageManager = this.getStorageManager();
        var domManager = this.getDomManager();
        for (var [name,componentSpecifier] of storageManager.getComponentSpecifierMap()){
            var components = componentSpecifier.getComponents();
            var documents = components.map(component => component.getDocument());
            var selector = componentSpecifier.getSelector();
            domManager.insertSubDocuments(documents, selector);
        }
    }

    /* added 13-05-2021 */
    insertSubComponent(name, replace){  
        var storageManager = this.getStorageManager();
        var domManager = this.getDomManager();
        var selector = storageManager.getSelector(name);
        var component = storageManager.getComponents(name)[0];
        var document = component.getDocument();
        domManager.insertSubDocument(document, selector, replace)       
    }

    /* added 13-05-2021 */
    /*
    removeSubComponent(componentName){ 
        var storageManager = this.getStorageManager();
        var parentSelector = storageManager.getSelector(componentName);
        var domManager = this.getDomManager();
        domManager.removeSubDocument(parentSelector);
    }
    */



    initComponent(componentOptions){
        var domOptions; 
        if (this.hasComponentOptions(componentOptions)) domOptions = componentOptions.getDomOptions();  /* added 20-05-2021 */
        var containerOptions = this.createContainerOptions(domOptions);
        var context;
        if (this.hasComponentOptions(componentOptions)) context = componentOptions.getContext();  /* added 20-05-2021 */
        var contentOptions = this.createContentOptions(context);  
        
        if (this.hasComponentOptions(componentOptions)){
            contentOptions = componentOptions.getContentOptions() || contentOptions;
            containerOptions = componentOptions.getContainerOptions() || containerOptions;
        }
        this.setContentOptions(contentOptions);
        var domManagerOptions = new DomManagerOptions(containerOptions, contentOptions, this);
        this.initDomManager(domManagerOptions);
        this.initEventManager();
        this.initStorageManager();
        this.initEventListeners();
    }

    /* added 22-05-2021 */
    emitCustomEvent(eventName, detail){  // TMP. Should be located in Component
        var event = new CustomEvent(eventName, { detail, bubbles: true });  // https://developer.mozilla.org/fr/docs/Web/API/Event/Event
        this.getDomManager().getDomNode().dispatchEvent(event);
    } 

    // ============
    // API (public)
    //-------------

    getDocument(){ /* !! this will remove the node from its current doc. It it is part of anothe doc, it will be removed !!*/
        var domManager = this.getDomManager();
        return domManager.getDocument();
    }

    getDomNode(){
        return this.getDomManager().getDomNode();
    }

    build(){
        //console.log('build component')
        /*
        var contentOptions = this.getContentOptions();
        var domManager = this.getDomManager();
        domManager.buildContent(contentOptions);
        */

        this.updateManagerListeners();

        //this.insertSubComponents();
        return;
    }

    setContentOptions(contentOptions){
        if (contentOptions instanceof LayoutOptions || contentOptions instanceof PartsOptions)
            this.contentOptions = contentOptions; // should be instanceof LayoutOptions, partsOptions 
    }

    /* added 23-05 */
    buildContent(){
        var contentOptions = this.getContentOptions();
        this.getDomManager().buildContent(contentOptions);
    }

    /* added 26-05 */
    removeAllSubComponents(){
        var storageManager = this.getStorageManager();
        var names = storageManager.getAllComponentNames();
        names.forEach(name => this.removeSubComponent(name))
    }

    /* added 24-05 */
    removeSubComponent(componentName){
        var storageManager = this.getStorageManager();
        var domManager = this.getDomManager();
        var components = storageManager.getComponents(componentName);
        //1. remove from the tree
        if (components) components.forEach(component =>{
            var document = component.getDocument()   /* in fact this is sufficient to remove from the current tree */
            // domManager.removeSubDocument2(document)
        })
        //2. remove from the storage 
        storageManager.removeComponents(componentName);
    }

    /* added 23-05 */
    addSubComponent(component,name,selector){
        this.addSubComponents([component],name,selector);
    }



    /* added 23-05 */
    addSubComponents(newComponents,name,selector){
        var storageManager = this.getStorageManager();
        var domManager = this.getDomManager();
       
        var newNodes = newComponents.map(component => component.getDomNode());

        var currentComponents = storageManager.getComponents(name);
        var currentNode;
        if (currentComponents){    // if currentComponents replace
            while (currentComponents.length-1){
                var currentComponent = currentComponents.pop();
                // domManager.removeDocument(currentComponent.getDocument()); 
                domManager.removeNode(currentComponent.getDomNode())      
            }
            var currentComponent = currentComponents.pop(); // last element
            currentNode = currentComponent.getDomNode();
        }
        if (currentNode) domManager.replaceNode(newNodes, currentNode);
        else{
            var newDocuments = newComponents.map(component => component.getDocument());
            domManager.insertSubDocuments(newDocuments, selector);  // replace by subNodes ?
        } 
        storageManager.addComponents(newComponents, name, selector);
    }

    // ============
    // overloadable
    // ------------


    createContainerNode(){
        return Component.defaultContainerNode();
    }

    createHeadNode(){
        var style = document.createElement('style');
        style.innerText = ".container{ width: 300px; height: 200px; background-color: light pink}";
        return style;
    }

    createContentNode(){
        var div = document.createElement('div');
        div.setAttribute('style','border:3px solid blue');
        div.classList.add('content')
        div.innerText = "content";
        return div;
    }

    defineEventListeners(eventManager){}

    // ======
    // static
    // ------

    static dummyTrue(){ return true}

    static dummyNull(){ return null }

    static defaultContainerNode(){
        var div = document.createElement('div');
        return div;
    }

    static defaultContainerNode2(){
        var button = document.createElement('button');
        button.innerText = "Default Component";
        return button;
    }
}

/*
new ComponentOptions(containerOptions, contentOptions)
componentOptions.setContainerContext will be passed to the createcontainerNode function 
*/

export class ComponentOptions extends DomManagerOptions{
    constructor(...params){
        super(...params);

    }

    getDomManagerOptions(){ return this}

    setDomOptions(domOptions){ this.domOptions = domOptions }
    getDomOptions(){ return this.domOptions }

    setContext(context){ this.context = context }
    getContext(){ return this.context }
}